import { render, staticRenderFns } from "./SettingsCommunicationList.vue?vue&type=template&id=2d97c1d0&scoped=true&"
import script from "./SettingsCommunicationList.vue?vue&type=script&lang=ts&"
export * from "./SettingsCommunicationList.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsCommunicationList.vue?vue&type=style&index=0&id=2d97c1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d97c1d0",
  null
  
)

export default component.exports